import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageTrainingsList,
  PageTraining,
} from '../pages/trainings';

const RouteTrainings = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageTrainingsList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageTraining />
      </Route>
    </Switch>
  );
};

export default RouteTrainings;
